const STORAGE_KEY = 'genai_notifications_read_locally';

export function loadPersistedReadIds() {
    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        const ids = raw ? JSON.parse(raw) : [];
        return new Set(Array.isArray(ids) ? ids : []);
    } catch {
        return new Set();
    }
}

export function persistReadIds(readIds) {
    try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...readIds]));
    } catch {
        // ignore quota / private mode
    }
}

export function clearPersistedReadIds() {
    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch {
        // ignore
    }
}

/**
 * Keeps notifications marked read in the UI when the server feed is briefly stale.
 */

export function applyLocalReadState(items, readIds) {
    if (!items?.length || !readIds?.size) return items || [];
    return items.map((item) =>
        readIds.has(item.recipient_id)
            ? {
                  ...item,
                  is_read: true,
                  read_at: item.read_at ?? new Date().toISOString(),
              }
            : item
    );
}

export function countStaleServerUnread(items, readIds) {
    if (!items?.length || !readIds?.size) return 0;
    return items.filter(
        (item) => readIds.has(item.recipient_id) && !item.is_read
    ).length;
}

/** Badge count: trust merged list when we have items, else API count minus stale reads */
export function resolveUnreadCount(apiCount, items, readIds) {
    const count = apiCount ?? 0;
    if (!items?.length) return Math.max(0, count);
    const merged = applyLocalReadState(items, readIds);
    const listUnread = merged.filter((item) => !item.is_read).length;
    const staleUnread = countStaleServerUnread(items, readIds);
    return Math.min(listUnread, Math.max(0, count - staleUnread));
}
